import { ExclamationCircleOutlined, WarningFilled } from "@ant-design/icons";
import React from "react";
import "./style.scss";
import { Space } from "antd";

const AlertModal = ({ message, children = <div></div> }) => {
  return (
    <div
      style={{
        textAlign: "center",
        fontWeight: "bold",
        // display: "flex",
        display: "grid",
        gap: 12,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <ExclamationCircleOutlined className="alert-svg" />
        </span>
        <span>{message}</span>
      </div>
      {children}
    </div>
  );
};

export default AlertModal;
